import React from "react";
import Button from "../../components/ui/Button";
import Alert from "../../components/ui/Alert";
import "./UiKit.scss";

const UiKit = () => {
  return (
    <div className="ui-kit">
      <div className="ui-kit__container">
        <header className="ui-kit__header">
          <h1>UI Kit · Truco XP</h1>
          <p>Componentes baseados no design do Figma.</p>
        </header>

        <div className="ui-kit__grid">
          {/* ----------- BUTTONS ----------- */}
          <section className="ui-kit__panel">
            <h2 className="ui-kit__panel-title">button</h2>

            <div className="ui-kit__stack">
              <Button variant="primary">Entrar</Button>
              <Button variant="secondary">Entrar</Button>
              <Button variant="outline">Entrar</Button>
              <Button variant="dark">Entrar</Button>
              <Button variant="ghost">Entrar</Button>
              <Button variant="primary" disabled>
                Entrar
              </Button>
              <Button variant="primary" loading />
            </div>
          </section>

          {/* ----------- ALERTS ----------- */}
          <section className="ui-kit__panel">
            <h2 className="ui-kit__panel-title">alerts</h2>

            <div className="ui-kit__stack">
              <Alert variant="success" closable>
                Alert
              </Alert>
              <Alert variant="error" closable>
                Alert
              </Alert>
              <Alert variant="warning" closable>
                Alert
              </Alert>
              <Alert variant="dark" closable>
                Alert
              </Alert>
              <Alert
                variant="dark"
                actionLabel="Desfazer"
                onAction={() => console.log("Desfazer")}
              >
                Alert
              </Alert>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default UiKit;
